import { Circle as a } from "@react-three/drei";
import { memo as f } from "react";
import { MathUtils as l } from "three";
import { ScreenSizer as p } from "../../3d/screen-sizer/index.js";
import { jsx as t } from "react/jsx-runtime";
const h = [-l.DEG2RAD * 90, 0, 0], F = f(function({
  radius: e,
  color: o,
  renderOrder: m,
  opacity: r,
  userData: i,
  onClick: n,
  ...s
}) {
  return /* @__PURE__ */ t(p, {
    rotation: h,
    ...s,
    children: /* @__PURE__ */ t(a, {
      args: [e, 16],
      renderOrder: m,
      userData: i,
      onClick: n,
      children: /* @__PURE__ */ t("meshLambertMaterial", {
        color: o,
        opacity: r,
        depthTest: !1,
        depthWrite: !1,
        transparent: r !== void 0 && r !== 1
      })
    })
  });
});
export {
  F as DotFC
};
//# sourceMappingURL=index.js.map
